import { lazy } from "react";
import { Boxes, Layers, ListTree, Network, Ruler } from "lucide-react";

import type { TabRoute } from "@/lib/routes";

// Lazy-load each tab so the product-catalog page only pulls the active tab's
// chunk. Tab components default-export their named component to satisfy
// React.lazy's shape.
const OfferingsTab = lazy(() => import("./OfferingsTab"));
const ComponentsTab = lazy(() => import("./ComponentsTab"));
const StructuresTab = lazy(() => import("./StructuresTab"));
const UnitsTab = lazy(() => import("./UnitsTab"));
const CostComponentsTab = lazy(() => import("./CostComponentsTab"));

export const PRODUCT_CATALOG_TAB_ROUTES: ReadonlyArray<TabRoute> = [
  { path: "offerings", label: "Offerings", icon: Boxes, element: <OfferingsTab /> },
  { path: "components", label: "Components", icon: Layers, element: <ComponentsTab /> },
  { path: "structures", label: "Structures", icon: Network, element: <StructuresTab /> },
  { path: "units", label: "Units", icon: Ruler, element: <UnitsTab /> },
  {
    path: "cost-components",
    label: "Cost Components",
    icon: ListTree,
    element: <CostComponentsTab />,
  },
];
